
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { login } from '@api/connectors/klientix'

const TASKS = [
    {
        title: 'Перейдите в настройки аккаунта',
        body: 'Откройте <a href="https://klientiks.ru/clientix/settings/account" target="_blank" rel="noopener noreferrer">https://klientiks.ru/clientix/settings/account</a>',
    },
    {
        title: 'Откройте раздел API',
        body: 'Включите настройку «Включить API».',
    },
    {
        title: 'Скопируйте данные',
        body: 'Скопируйте ID аккаунта, ID юзера и токен авторизации.',
    },
]

export default {
    name: 'KlientixAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const validLogin = ref<boolean | null>(null)
        const loading = ref(false)
        const creds = ref({
            access_token: '',
            user_id: '',
            account_id: '',
        })

        const currentAddingConnector = computed(
            () => store.state.project.currentAddingConnector
        )

        const btnDisabled = computed(() =>
            Object.values(creds.value).some((v) => !String(v || '').trim())
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const adding = currentAddingConnector.value
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: adding?.type ?? adding,
            })
            const isLogin = await login(connector, creds.value)
            if (isLogin) {
                store.commit('project/setLoggedAddingConnector', connector)
                root.$parent.$emit('login')
            }
            validLogin.value = isLogin
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Войти',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            creds,
            validLogin,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
